import React, { useState } from "react";
import styled from "styled-components";
import { useDownloadModalStore } from "../../Store/store";
import { toAutoGeoJSON } from "../../util/download/toAutoGeoJSON";
import { toAutoKML } from "../../util/download/toAutoKML";
import { toAutoCSV } from "../../util/download/toAutoCSV";
import { downloadFile } from "../../util/download/downloadFile";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #333;
  border-radius: 12px;
  padding: 24px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

const ModalTitle = styled.h2`
  margin: 0 0 16px 0;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
`;

const ModalDescription = styled.p`
  margin: 0 0 20px 0;
  color: #dfdfdf;
  font-size: 14px;
  line-height: 1.5;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #dfdfdf;
  font-weight: 500;
  font-size: 14px;
`;

const Select = styled.select`
  width: 100%;
  padding: 12px;
  border: 2px solid #dfdfdf;
  border-radius: 8px;
  font-size: 14px;
  background-color: #333;
  color: #dfdfdf;
  cursor: pointer;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #00ff99;
  }

  &:hover {
    border-color: #00ff99;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

const Button = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  color: #dfdfdf;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  ${(props) =>
    props.variant === "primary"
      ? `
    background-color: #00ff99;
    color: #333; 
    
    &:hover {
      background-color: #00e68a;
    }
    
    &:active {
      background-color: #00cc7a;
    }
  `
      : `
    background-color: #333;
    color: #dfdfdf;
    border: 1px solid #dfdfdf;
    
    &:hover {
      background-color: #dfdfdf;
    }
    
    &:active {
      background-color: #dfdfdf;
    }
  `}
`;

export default function DownloadAutoModal({ areaDataAuto }) {
  const [selectedFormat, setSelectedFormat] = useState("geojson");
  const { closeModalAuto } = useDownloadModalStore();

  const handleCancel = () => {
    closeModalAuto();
  };
  const handleDownload = () => {
    const currentUrl = window.location.href;
    // const hasPotree = currentUrl.includes("potree");
    let content, filename, mimeType;

    switch (selectedFormat) {
      case "geojson":
        const geoJSON = toAutoGeoJSON(areaDataAuto);
        content = JSON.stringify(geoJSON, null, 2);
        filename = "area.geojson";
        mimeType = "application/geo+json";
        break;
      case "kml":
        const kml = toAutoKML(areaDataAuto);
        content = kml;
        filename = "area.kml";
        mimeType = "application/vnd.google-earth.kml+xml";
        break;
      case "csv":
        const csv = toAutoCSV(areaDataAuto);
        content = csv;
        filename = "area.csv";
        mimeType = "text/csv";
        break;
      default:
        console.error("Unknown format:", selectedFormat);
        return;
    }

    downloadFile(content, filename, mimeType);
    closeModalAuto();
  };
  return (
    <ModalOverlay onClick={handleCancel}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalTitle>파일 다운로드</ModalTitle>
        <ModalDescription>
          다운로드할 파일 형식을 선택해주세요. 선택한 형식으로 영역 데이터를
          다운로드할 수 있습니다.
        </ModalDescription>

        <FormGroup>
          <Label htmlFor="format-select">파일 형식</Label>
          <Select
            id="format-select"
            value={selectedFormat}
            onChange={(e) => setSelectedFormat(e.target.value)}
          >
            <option value="geojson">GeoJSON (.geojson)</option>
            <option value="kml">KML (.kml)</option>
            <option value="csv">CSV (.csv)</option>
          </Select>
        </FormGroup>

        <ButtonGroup>
          <Button onClick={handleCancel}>취소</Button>
          <Button variant="primary" onClick={handleDownload}>
            다운로드
          </Button>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
}
